// import { axios as apiService } from '../../service/axiosService';
// import { BASE_URL } from '@service/apis';
import alert from '../alert/index';
import {
  CommentScrollKey,
  directUser,
  dispatchCommentScrollCheckEvent,
} from './index.js';
import CryptoJS from 'crypto-js';

// the following members should implement by developer

export const shouldScrollInToView = (anchorRecord, anchorId) =>
  anchorRecord?.componentName === anchorId ||
  anchorRecord?.identifier === anchorId;

export const checkUserOnSamePage = (history, targetInfo, targetModule) => {
  const { location } = history;
  const pathname = location.pathname;
  const { projectId } = targetInfo;
  const currentProjectId = window.SessionStorage.getItem('currentId');
  return pathname.includes(targetModule.key) && projectId === currentProjectId;
};

// the key of urlMap

export const openSectionCommentPanel = (anchorId) => {
  const icon = document.querySelector(
    `[data-comment-component-anchor=\'${anchorId}\']`,
  );
  icon && icon.click();
};

// use in notification center
// const ProjectHomeComponentName = {
//   complexity: 'Deal Complexity',
//   navigator: 'Accelerating the Transition',
//   lifecycle: 'M&A Lifecycle - Integration',
//   lifecycleDivestitures: 'M&A Lifecycle - Divestiture',
// };

// the following pages don't have SectionComment component for their page level comment

export const addScrollRecordToProvider = (
  commentScrollRecord,
  commentListType,
) => {
  let anchorScrollRecord = sessionStorage.getItem(CommentScrollKey);
  anchorScrollRecord = anchorScrollRecord
    ? JSON.parse(anchorScrollRecord)
    : null;
  anchorScrollRecord.commentListType = commentListType;
  commentScrollRecord.current = anchorScrollRecord;
  sessionStorage.removeItem(CommentScrollKey);

  setTimeout(() => {
    dispatchCommentScrollCheckEvent();
  }, 300);
};

// export const consumeCommentScrollRecord = (wrapperClassname = '') => {
//   let anchorScrollRecord = sessionStorage.getItem(CommentScrollKey);
//   if (anchorScrollRecord) {
//     try {
//       anchorScrollRecord = JSON.parse(anchorScrollRecord);
//       if (
//         anchorScrollRecord.channel &&
//         anchorScrollRecord.actionType ===
//           CommentActionType.CommentScrollIntoView
//       ) {
//         const anchorNode = document.querySelector(
//           `${wrapperClassname} [data-comment-channel=\'${anchorScrollRecord.channel}\']`,
//         );
//         if (anchorNode) {
//           anchorNode.scrollIntoView({
//             behavior: 'smooth',
//             block: 'nearest',
//             inline: 'start',
//           });
//           sessionStorage.removeItem(CommentScrollKey);
//         }
//       }
//     } catch (e) {
//       console.log(e);
//     }
//   }
// };
const isOnShownSource = (thread, accessibleModules) => {
  const { module, component } = thread;
  const identifier = thread.commentIdentifier || thread.identifier;

  const moduleShouldShow =
    Object.keys(accessibleModules).includes(module) ||
    accessibleModules._otherModule?.includes(identifier);

  if (!moduleShouldShow) {
    return false;
  }

  const allowAllComps = accessibleModules[module] === '*';

  if (allowAllComps) {
    return true;
  }

  const isPageLevel = thread.component === '' || thread.component == null;

  return (
    isPageLevel ||
    accessibleModules[module].some(
      (comp) => component.indexOf(comp) !== -1 || comp === identifier,
    )
  );
};

export const onNotificationClick = (
  notificationItem = {},
  setPanelVisible,
  history,
  callback,
  notificationBeforeJump,
  notificationCheckUserOnSamePage,
  notificationUrlMap,
  accessibleModules = null,
) => {
  const {
    module,
    component,
    projectId,
    commentDeleteFlag,
    commentId,
    commentIdentifier,
    commentChannelStatus,
    commentChannel,
  } = notificationItem;

  if (callback) {
    callback();
  }

  if (commentDeleteFlag) {
    alert.warning({
      content: `The comment has been deleted.`,
    });
    return;
  }

  if (
    accessibleModules !== null &&
    !isOnShownSource(notificationItem, accessibleModules)
  ) {
    alert.warning({
      content: `The ${module} ${
        component === '' ? '' : `or ${component} `
      }has been hidden, please unhide it and check the details.`,
    });
    return;
  }

  setPanelVisible(false);

  directUser(
    history,
    notificationUrlMap,
    {
      moduleName: module,
      componentName: component,
      commentId,
      projectId,
      identifier: commentIdentifier,
      channel: commentChannel,
      channelStatus: commentChannelStatus,
    },
    notificationBeforeJump,
    notificationCheckUserOnSamePage || checkUserOnSamePage,
  );
};
const aesKey = 'M&AGateway';

export const getSessionStorage = (key) => {
  const value = window.SessionStorage.getItem(key);

  if (
    typeof value === 'string' &&
    !['loginProgress', 'hasAuth'].includes(key)
  ) {
    // console.log('value: ', value, key);
    const decrypted = CryptoJS.AES.decrypt(value, aesKey).toString(
      CryptoJS.enc.Utf8,
    );
    // console.log('decrypted: ', decrypted);
    return JSON.parse(decrypted).value;
  }
  return value;
};
